import request from '../util/request'

const baseURL = '/base-api'
export function getAgreementData (data) {
  return request.service({
    url: `/business/sysAgreement/listNewestAgreement`,
    method: 'post',
    data,
    baseURL
  })
}

// 发送验证码请求
export function sendCode (data, headers) {
  return request.post('/system/user/sendcode', data, headers)
}

export function getSmsCaptcha (data) {
  return request.post('/auth/login/validateCode', data)
}

export function getMpSmsCaptcha (data) {
  return request.post('/auth/login/mpValidateCode', data)
}

/**
 *
 * @description 注册
 */
export function registered (data, headers) {
  return request.post('/system/user/register', data, headers)
}

/**
 *
 * @description  检验channelNo
 */
export function channelNo (params) {
  return request.service({
    url: `/channel/sysChannelManagelist/allList`,
    method: 'get',
    params,
    baseURL
  })
}

/**
 *
 * @description  检验channelNo
 */
export function channelNo1 (params) {
  return request.get('/vat/sysActivity/queryExpoActivitys', params)
}

/*
 *@description 首页获取banner
 */
export function getSysPosterConfigList (params) {
  return request.service({
    url: `/business/posterConfig/merc/list`,
    method: 'get',
    params,
    baseURL
  })
}

export function linkToProgram (data) {
  let headers = {
    processData: 'false',
    contentType: 'false'
  }
  return request.post('/system/mp/util/generate', data, headers)
}

export function iprServiceItems (params) {
  return request.get('/ipr/web/websiteConfig/iprServiceItems', params)
}

// 获取麦学堂目录列表
export function getCatalogueList (type) {
  return request.get(`/ipr/api/iprSchool/catalogueList/${type}`)
}

export function iprList (params) {
  return request.get('/ipr/web/websiteConfig/iprList', params)
}

// 从欧税通的后台管理，获取页面配置列表
export function getPageConfigList (params) {
  return request.service({
    url: `/business/biz/pageConfig/allInfo`,
    method: 'get',
    params,
    baseURL
  })
}

// 获取老带新信息
export function getInviteInfo (params) {
  return request.service({
    url: `/business/merc/activity/invite/inviteConfig`,
    method: 'get',
    params,
    baseURL
  })
}

// 获取渠道配置信息
export function getChannelPageConfig (params) {
  return request.service({
    url: `/business/channelPageConfig/merc/getConfig`,
    method: 'get',
    params,
    baseURL
  })
}

// 获取渠道奖励
export function getRegisterAward (params) {
  return request.service({
    url: `/business/channelPageConfig/merc/getRegisterAward`,
    method: 'get',
    params,
    baseURL
  })
}

export function getCurrentAct (params) {
  return request.service({
    url: `/business/officialQuery/getHomePageInfo`,
    method: 'get',
    params,
    baseURL
  })
}

// 获取转盘活动带新信息
export function validDraw (params) {
  return request.service({
    url: `/activity/activityDraw/validDraw`,
    method: 'get',
    params,
    baseURL
  })
}

export function adRecordBanner (params) {
  return request.service({
    url: '/business/posterConfig/merc/incrCount',
    method: 'post',
    data: params,
    baseURL
  })
}



// WEBPACK FOOTER //
// ./src/api/land.js